"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _react = _interopRequireDefault(require("react"));
var _StarIcon = _interopRequireDefault(require("./StarIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var StarRating = function StarRating(_ref) {
  var stars = _ref.stars,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$listClassName = _ref.listClassName,
    listClassName = _ref$listClassName === void 0 ? '' : _ref$listClassName,
    _ref$starSize = _ref.starSize,
    starSize = _ref$starSize === void 0 ? 15 : _ref$starSize,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#1B4021' : _ref$color;
  var getDecimals = function getDecimals(i) {
    return (0, _lodash.clamp)(Math.round((stars - i) * 10), 0, 10);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('relative', className)
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames.default)('relative p-0 mb-0 list-none flex gap-x-[7px]', listClassName)
  }, (0, _lodash.times)(5, function (i) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "relative",
      key: i
    }, /*#__PURE__*/_react.default.createElement(_StarIcon.default, {
      color: color,
      decimals: getDecimals(i),
      size: starSize
    }));
  })));
};
var _default = StarRating;
exports.default = _default;